import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	searchNotIssueResult: null, //searchResult, // null, // searchResult
	currentPage: 0,
	criteria: null,
	}

const search = (state = initialState, action) => {
	switch (action.type) {
	case ActionTypes.SEARCH_BOOKING_NOTISSUE_SUCCESS:
		return Object.assign({}, state, {
			searchNotIssueResult: action.payload,
			criteria: action.criteria
		});
	case ActionTypes.SEARCH_BOOKING_NOTISSUE_FAILURE:
		return Object.assign({}, state, {
			searchNotIssueResult: action.payload,
		});
	case ActionTypes.CLEAR_BOOKING_SEARCH_NOTISSUE_RESULT:
		return Object.assign({}, state, {
			searchNotIssueResult: null,
			currentPage: 0,
			criteria: null,
		});
	case ActionTypes.CHANGE_NOTISSUE_PAGE:
		return Object.assign({}, state, {
			currentPage: action.payload
		});
	default:
		return state;
	}
};

export default search;
